<section class="section_one">
    <div class="container">
        <div class="row">
            <div class="col-md-12">
                <!-- desktop table view open-->
                <div class="ibox">
                    <form [formGroup]="myGroup" #inputField11>
                        <div>
                            <div class="ibox-title report_flexweb">
                                <div>
                                    <h5> CREATE COURSE TRACK MASTER</h5>
                                </div>
                                <div>
                                    <figure>
                                        <img src="../../assets/image/Group 28269.svg" [mat-dialog-close]="true" />
                                    </figure>
                                </div>
                            </div>
                            <div class="card">
                                <mat-form-field appearance="outline">
                                    <mat-label>Enter Course Track Name</mat-label>
                                    <input matInput placeholder="Placeholder" formControlName="Trackname" #inputField1
                                        oninput="this.value = this.value.toUpperCase()">
                                </mat-form-field>
                                <mat-form-field appearance="outline">
                                    <mat-label>Enter Course Track Code</mat-label>
                                    <input matInput placeholder="Placeholder" formControlName="TrackCode" #inputField2
                                        oninput="this.value = this.value.toUpperCase()">
                                </mat-form-field>
                                <mat-form-field>
                                    <mat-label>Class</mat-label>
                                    <mat-select name="state" formControlName="classname" (click)="Classinput(matSelect)">
                                        <input matInput type="text" class="input_border" [formControl]="Class" />
                                        <mat-option *ngFor="let option of classNames | async"
                                            [value]="option.displayName">{{ option.displayName }}</mat-option>
                                    </mat-select>
                                </mat-form-field>
                                <mat-form-field>
                                    <mat-label>Select Medium</mat-label>
                                    <mat-select name="state" formControlName="mediumname" (click)="Mediuminput(matSelect)">
                                        <input matInput type="text" class="input_border" [formControl]="Medium" />
                                        <mat-option [value]=option.medium *ngFor="let option of mediums | async"> {{
                                            option.medium === 'T' ? 'TELUGU' : option.medium === 'E' ? 'ENGLISH' :
                                            option.medium }}
                                        </mat-option>
                                    </mat-select>
                                </mat-form-field>
                                <mat-form-field>
                                    <mat-label>Select Group</mat-label>
                                    <mat-select name="state" formControlName="groupname" (click)="Groupinput(matSelect)" >
                                        <input matInput type="text" class="input_border" [formControl]="Group" />
                                        <mat-option [value]=option.groupName *ngFor="let option of group| async"> {{
                                            option.groupName }} </mat-option>
                                    </mat-select>
                                </mat-form-field>
                                <mat-form-field>
                                    <mat-label>Select Orientation</mat-label>
                                    <mat-select name="state" formControlName="Orientationname" (click)="Orientationinput(matSelect)">
                                        <input matInput type="text" class="input_border" [formControl]="Orientation"
                                            [disabled]="isInputDisabled" />
                                        <mat-option *ngFor="let option of orientationname| async"
                                            [value]=option.orientation> {{ option.orientation }} </mat-option>
                                    </mat-select>
                                </mat-form-field>
                                <mat-form-field>
                                    <mat-label>Track Type</mat-label>
                                    <mat-select name="state" formControlName="trackname" (click)="Trackinput(matSelect)">
                                        <input matInput type="text" class="input_border" [formControl]="Track" />
                                        <mat-option *ngFor="let item of tpye | async"
                                            [value]=item.trackType>{{item.trackType}}</mat-option>
                                    </mat-select>
                                </mat-form-field>
                                <mat-form-field>
                                    <mat-label>Select Stream</mat-label>
                                    <mat-select name="state" formControlName="streamname" (click)="Streminput(matSelect)">
                                        <input matInput type="text" class="input_border" [formControl]="Strem" />
                                        <mat-option [value]=item.streamName
                                            *ngFor="let item of stream | async">{{item.streamName}}</mat-option>
                                    </mat-select>
                                </mat-form-field>
                                <mat-form-field>
                                    <mat-label>Select Sub Stream</mat-label>
                                    <mat-select name="state" formControlName="substreamname" (click)="Substreaminput(matSelect)">
                                        <input matInput type="text" class="input_border" [formControl]="Substream" />
                                        <mat-option [value]=item.subStreamName
                                            *ngFor="let item of substream | async">{{item.subStreamName}}</mat-option>
                                    </mat-select>
                                </mat-form-field>
                            </div>
                            <div class="display">
                                <div style="margin-left: 15px;">
                                    <label>Coaching Type: </label>
                                    <mat-radio-group formControlName="radio" #inputField10>
                                        <mat-radio-button *ngFor="let item of coachingType"
                                            [value]="item.coachngType.toLowerCase()">{{item.coachngType}}</mat-radio-button>
                                    </mat-radio-group>
                                </div>
                            </div>
                            <div class="col-lg-12 text-center">
                                <button type="button" class="cctv_notebtn" (click)="updata()">{{data11 ? 'UPDATE
                                    ':'SAVE'}}</button>
                            </div>
                        </div>
                    </form>
                    <!-- desktop table view close-->
                </div>
            </div>
        </div>
    </div>
</section>


<ngx-spinner bdColor="rgba(51,51,51,0.8)" size="medium" color="#fff" type="ball-scale-multiple">
    <p style="font-size: 20px; color: white">Loading...</p>
</ngx-spinner>